
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';


@Injectable({
  providedIn: 'root'
})
export class ProductItemService {

  constructor(private http: HttpClient) { 
  }


  GetAllProductItem(): Observable<any> {
    return this.http.get(environment.apiUrl + 'ProductItem/GetAllProductItem');
  }

  GetProductItemByBarCodeAndCheck(barcode): Observable<any> {
    return this.http.get(environment.apiUrl + 'ProductItem/GetProductItemByBarCodeAndCheck?barcode=' + barcode + '&idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));

  }

  GetProductItemByBarCode(barcode): Observable<any> {
    return this.http.get(environment.apiUrl + 'ProductItem/GetProductItemByBarCode?barcode=' + barcode+ '&idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }

  GetProductItemByIdInventory(id): Observable<any> {
    return this.http.get(environment.apiUrl + 'ProductItem/GetProductItemByIdInventory?id=' + id);
  }

  update(model: any) {
    return this.http.patch(environment.apiUrl + 'ProductItem/Update', model);
  }

  GetAvailableProductItemCount() {
    return this.http.get(environment.apiUrl + 'ProductItem/GetAvailableProductItemCount?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }
}
